exports.LANGUAGE = {
  en: 'English',
  ja: '日本語',
  ko: '한국어',
  // 'zh-cn': '中文(简体)',
  'zh-Hans': '',
  'zh-Hant': '繁體中文',
  'zh-tc': '',
  es: 'Español',
  pt: 'Português',
  de: 'Deutsch',
  fr: 'Français',
  ru: 'Русский',
  th: 'ภาษาไทย',
  // it: 'Italiano',
  // in: 'Indonesia',
  id: ''
};
exports.LANGUAGE_NAME = {
  en: '英文',
  'zh-cn': '简体中文',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁体中文',
  'zh-tc': '繁体中文',
  ja: '日语',
  ko: '韩语',
  th: '泰语',
  it: '意大利语',
  in: '印度尼西亚语',
  id: '印度尼西亚语',
  es: '西班牙',
  ru: '俄语',
  de: '德语',
  fr: '法语',
  pt: '葡萄牙语'
};
exports.XIGUA_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'zh-Hant',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  it: 'it',
  id: 'in',
  es: 'es',
  ru: 'ru',
  de: 'de',
  fr: 'fr',
  'zh-Hant': 'zh-Hant',
  in: 'in',
  pt: 'pt'
};

exports.ZT_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'cht',
  ja: 'jp',
  ko: 'kor',
  th: 'th',
  it: 'it',
  id: 'id',
  es: 'spa',
  ru: 'ru',
  de: 'de',
  fr: 'fra',
  'zh-Hant': 'cht',
  in: 'id',
  pt: 'pt'
};

/**
 *
 * zho（简体中文）
 * eng（英文）
 * zho-tw（台湾）
 * zho-hk（香港）
 * udm（维吾尔语）
 * jpn（日文）
 * ind（印尼）
 * kor（韩语）
 * rus（俄语）
 * ara（阿拉伯语）
 * spa（西班牙语）
 * pon（巴西葡语）
 * por（欧洲葡语）
 * fra（法语）
 * deu（德语）
 * @type {{de: string, 'zh-HANT': string, ru: string, ko: string, th: string, ja: string, en: string, it: string, id: string, fr: string, es: string}}
 */
exports.GEETEST_LANGUAGE = {
  en: 'eng',
  'zh-cn': 'zho',
  'zh-Hans': 'zho',
  'zh-tc': 'zho-hk',
  ja: 'jpn',
  ko: 'kor',
  th: 'eng',
  it: 'eng',
  id: 'ind',
  es: 'spa',
  ru: 'rus',
  de: 'deu',
  fr: 'fra',
  'zh-Hant': 'zho-hk',
  in: 'ind',
  pt: 'por'
};

exports.PROTOCOL = {
  en: {
    appointment: '//www.mechabreak.com/show-1034-38-1.html',
    cookie: '//www.mechabreak.com/show-1031-35-1.html',
    privacy: '//mechabreak.seasungames.com/show-1034-211-1.html',
    service: '//mechabreak.seasungames.com/show-1034-561-1.html'
  },
  ja: {
    appointment: '//www.mechabreak.com/show-1031-41-1.html',
    cookie: '//www.mechabreak.com/show-1031-36-1.html',
    privacy: '//mechabreak.seasungames.com/show-1033-209-1.html',
    service: '//mechabreak.seasungames.com/show-1033-210-1.html'
  },
  ko: {
    appointment: '//www.mechabreak.com/show-1031-40-1.html',
    cookie: '//www.mechabreak.com/show-1031-37-1.html',
    privacy: '//mechabreak.seasungames.com/show-1032-40-1.html',
    service: '//mechabreak.seasungames.com/show-1032-208-1.html'
  },
  'zh-Hant': {
    appointment: '//www.mechabreak.com/show-1031-39-1.html',
    cookie: '//www.mechabreak.com/show-1031-34-1.html',
    privacy: '//mechabreak.seasungames.com/show-1031-205-1.html',
    service: '//mechabreak.seasungames.com/show-1031-206-1.html'
  },
  es: {
    appointment: '//www.mechabreak.com/show-1094-146-1.html',
    cookie: '//www.mechabreak.com/show-1094-147-1.html',
    privacy: '//mechabreak.seasungames.com/show-1094-148-1.html',
    service: '//mechabreak.seasungames.com/show-1094-149-1.html'
  },
  pt: {
    appointment: '//www.mechabreak.com/show-1095-153-1.html',
    cookie: '//www.mechabreak.com/show-1095-152-1.html',
    privacy: '//mechabreak.seasungames.com/show-1095-151-1.html',
    service: '//mechabreak.seasungames.com/show-1095-150-1.html'
  },
  de: {
    appointment: '//www.mechabreak.com/show-1096-157-1.html',
    cookie: '//www.mechabreak.com/show-1096-156-1.html',
    privacy: '//mechabreak.seasungames.com/show-1096-155-1.html',
    service: 'https://mechabreak.seasungames.com/show-1096-154-1.html'
  },
  fr: {
    appointment: '//www.mechabreak.com/show-1097-161-1.html',
    cookie: '//www.mechabreak.com/show-1097-160-1.html',
    privacy: '//mechabreak.seasungames.com/show-1097-159-1.html',
    service: '//mechabreak.seasungames.com/show-1097-158-1.html'
  },
  ru: {
    appointment: '//www.mechabreak.com/show-1098-165-1.html',
    cookie: '//www.mechabreak.com/show-1098-164-1.html',
    privacy: '//mechabreak.seasungames.com/show-1098-163-1.html',
    service: '//mechabreak.seasungames.com/show-1098-162-1.html'
  },
  th: {
    appointment: '//mechabreak.seasungames.com/show-1238-242-1.html',
    cookie: '//mechabreak.seasungames.com/show-1034-324-1.html',
    privacy: '//mechabreak.seasungames.com/show-1238-244-1.html',
    service: '//mechabreak.seasungames.com/show-1238-242-1.html'
  }
};

const pcTest = '//test-zt.xoyo.games/mechabreak.seasungames.com/p/m/2025/03/21/index/';
const pcMaster = '//mechabreak.seasungames.com/p/m/2025/03/21/index/';
// const pcMaster = '//mechabreak.seasungames.com/p/m/2024/07/25/twitch-drop-rdJV68hwOPMImpJ4/';
exports.PC_ADDRESS = {
  en: {
    testUrl: pcTest + 'en/',
    masterUrl: pcMaster + 'en/'
  },
  ja: {
    testUrl: pcTest + 'ja/',
    masterUrl: pcMaster + 'ja/'
  },
  ko: {
    testUrl: pcTest + 'ko/',
    masterUrl: pcMaster + 'ko/'
  },
  'zh-Hant': {
    testUrl: pcTest + 'zh-Hant/',
    masterUrl: pcMaster + 'zh-Hant/'
  },
  es: {
    testUrl: pcTest + 'es/',
    masterUrl: pcMaster + 'es/'
  },
  pt: {
    testUrl: pcTest + 'pt/',
    masterUrl: pcMaster + 'pt/'
  },
  de: {
    testUrl: pcTest + 'de/',
    masterUrl: pcMaster + 'de/'
  },
  fr: {
    testUrl: pcTest + 'fr/',
    masterUrl: pcMaster + 'fr/'
  },
  ru: {
    testUrl: pcTest + 'ru/',
    masterUrl: pcMaster + 'ru/'
  },
  th: {
    testUrl: pcTest + 'th/',
    masterUrl: pcMaster + 'th/'
  }
};
